<div class="legal-shell">
  @if (legal.loading()) {
    <!-- No white card here: a quick, successful check should just leave the
         app visible behind the dimmed backdrop. Only show a minimal
         indicator once loading has taken long enough to be noticeable. -->
    @if (showLoadingIndicator) {
      <div class="legal-loading" role="status">
        <mat-spinner diameter="40"></mat-spinner>
        <p>Initialising application and loading...</p>
        <button mat-button type="button" (click)="app.logout()">Sign out</button>
      </div>
    }
  } @else {
    <section class="legal-panel" aria-labelledby="agreement-heading">
      <button mat-icon-button type="button" class="legal-signout" matTooltip="Sign out" aria-label="Sign out"
        (click)="app.logout()" [disabled]="busy">
        <mat-icon>logout</mat-icon>
      </button>
      <div class="legal-header">
        <mat-icon class="legal-header-icon">description</mat-icon>
        <h1 id="agreement-heading">Terms of Use and Privacy Policy</h1>
      </div>
      @if (legal.error()) {
        <p role="alert" class="legal-error">{{ legal.error() }}</p>
        <button mat-raised-button type="button" (click)="legal.refresh()">Retry</button>
      } @else if (legal.documents(); as documents) {
        <p>Please review version <strong>{{ documents.title }}</strong> before continuing.
          If the documents change, you will be asked to accept them again.</p>
        <mat-checkbox color="primary" [(ngModel)]="termsAccepted" [disabled]="busy">
          I agree to the <a [href]="documents.termsUrl" target="_blank" rel="noopener noreferrer"
            (click)="$event.stopPropagation()">Terms of Use</a>.
        </mat-checkbox>
        <mat-checkbox color="primary" [(ngModel)]="privacyAcknowledged" [disabled]="busy">
          I have read and acknowledge the <a [href]="documents.privacyUrl" target="_blank" rel="noopener noreferrer"
            (click)="$event.stopPropagation()">Privacy Policy</a>.
        </mat-checkbox>
        @if (error) {
          <p role="alert" class="legal-error">{{ error }}</p>
        }
        <mat-divider></mat-divider>
        <div class="legal-actions">
          <button mat-raised-button color="primary" type="button" (click)="accept()"
            [disabled]="busy || !termsAccepted || !privacyAcknowledged">
            {{ busy ? 'Saving agreement...' : 'Accept and continue' }}
          </button>
        </div>
      } @else {
        <p role="alert">The legal documents have not been published yet. Please contact your administrator.</p>
        <button mat-button type="button" (click)="legal.refresh()">Retry</button>
      }
    </section>
  }
</div>
